module.exports = __webpack_public_path__ + "static/cox-logo-0f378dffec2c2f5f31cbe3c49862de0d.png";